import SettingsContent from '../Wrapper.vue';
import Index from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/schoolClassSections'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'SCHOOL_CLASS_SECTION.HEADER',
        icon: 'book-contacts',
        showNewButton: true,
      },
      children: [
        {
          path: '',
          name: 'school_class_section_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'school_class_section_list',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
